export interface WealthPerson {
  id?: number;
  slug?: string;
  name: string;
  rank?: number;
  net_worth_usd?: number;
  source_of_wealth?: string;
  country?: string;
  image_url?: string;
  about?: string;
  estimated_wealth_text?: string;
  classification?: {
    country_tags?: string[];
    heritage_tags?: string[];
    wealth_tier?: string;
    ranking_scope?: string;
    presentation_mode?: "compact_ai" | "portrait_feature" | "historical_hero" | string;
  };
}

export interface WealthResponse {
  kind?: "richest" | "historical" | "founder" | "market_cap";
  title?: string;
  count?: number;
  items?: WealthPerson[];
  company_name?: string;
  founder_names?: string[];
  overview?: string;
  people?: WealthPerson[];
  company?: {
    name: string;
    slug?: string;
    ticker?: string;
    exchange?: string;
    currency?: string;
    market_cap_usd?: number | null;
    display_market_cap?: string;
    share_price?: number | null;
    daily_change_percent?: number | null;
    is_placeholder?: boolean;
    fetched_at?: string | null;
  };
  source?: { name?: string; url?: string };
  deterministic?: boolean;
  error?: string;
}

export function escapeWealthHtml(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function formatWealthValue(value: number | null | undefined): string {
  const amount = Number(value || 0);
  if (!amount) return "";
  if (amount >= 1_000_000_000_000) return `$${(amount / 1_000_000_000_000).toFixed(2).replace(/\.?0+$/, "")}T`;
  if (amount >= 1_000_000_000) return `$${(amount / 1_000_000_000).toFixed(1).replace(/\.0$/, "")}B`;
  if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  return `$${Math.round(amount).toLocaleString()}`;
}

export function wealthPersonImage(person: WealthPerson): string {
  const esc = escapeWealthHtml;
  return person.image_url
    ? `<img src="${esc(person.image_url)}" alt="${esc(person.name)}" loading="lazy" referrerpolicy="no-referrer" />`
    : `<div class="wealth-person-placeholder">${esc(person.name.charAt(0))}</div>`;
}
